import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47ed59de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__score-item print--avoid-page-break" }
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { class: "collapse-text__label" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "text"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = { class: "tab-content" }

import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"
  import ScoreItemText from "vue/applications/frontend/components/score-item-text.vue"
  import ScoreItemBubble from "vue/applications/frontend/components/score-item-bubble.vue"
  import ScoreItemShowMoreButton from "vue/applications/frontend/components/score-item-show-more-button.vue" 
  import TabbedContent from "vue/applications/frontend/components/tabbed-content.vue"
  import InfoItem from "vue/applications/frontend/components/info-item.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'score-item',
  props: {
    scoreItem: {
      type: Object,
    },
  },
  setup(__props) {

  const props = __props;

  const store = useStore();
  const currentValue = ref<any>(null);
  const values = ref<Array<{key: number, value: number, label: number}>> ([
    { key: 1, value: 1, label: 1 },
    { key: 2, value: 2, label: 2 },
    { key: 3, value: 3, label: 3 },
    { key: 4, value: 4, label: 4 },
  ]);
  const showMore = ref<boolean>(false);
  const isCollapsed = ref<boolean>(true);

  onMounted(() => {
    if (props.scoreItem) {
      currentValue.value = props.scoreItem.ivalue;
      if(props.scoreItem.free_text) currentValue.value = currentValue.value ?? props.scoreItem.previous_scores[0]?.value
    }
  });

  const name = computed(() => {
    if (props.scoreItem && currentValue.value != null) {
      return `${props.scoreItem.name_prefix}[${props.scoreItem.id}]`;
    }
    return null;
  });
  const lastPreviousScore = computed(() => {
    if (props.scoreItem && props.scoreItem.skip_last_previous_score)
      return null;
    const previousScores = props.scoreItem?.previous_scores || [];
    if (previousScores.length > 0) {
      return previousScores[0];
    }
    return null;
  });
  const filtered = computed(() => {
    // filtering is not even active
    if (!store.getters.filteringActive) {
      return false;
    }

    // Dont filter out required items
    if ((props.scoreItem || {}).required) {
      return false;
    }

    // get filters preprocessed from store
    const filtersFromStoreAsIDChecked = store.getters.filterIDToChecked;

    // We dont have previous scores
    if (((props.scoreItem || {}).previous_scores || []).length <= 0) {
      return !filtersFromStoreAsIDChecked[-1];
    }

    // Get last score from previous scores
    const lastScore = [...props.scoreItem?.previous_scores].reverse().pop();

    // get correctFilter
    const correctFilter =
      filtersFromStoreAsIDChecked[lastScore.score_level_id];

    if (correctFilter == null) {
      // undefined or null
      return false;
    }

    return !correctFilter;
  });
  const collapsible = computed(() => !props.scoreItem?.readonly && props.scoreItem?.is_collapsed);
  const collapsed = computed(() => collapsible.value && isCollapsed.value);
  const hasAdditionalInfo = computed(() => (props.scoreItem?.info_items || []).length > 0)
  const moreLabel = computed(() => {
    if (!props.scoreItem?.cumulate_scores) return null;  // don't show history if scores are not cumulatd
    if(hasAdditionalInfo.value && (props.scoreItem?.show_all_previous_values || !usesPreviousValues.value) ) return "weitere Informationen";
    if(hasAdditionalInfo.value && usesPreviousValues.value) return "letzte Einträge / weitere Informationen";
    if(usesPreviousValues.value) return "letzte Einträge";
    return null;
  });
  const layout = computed(() => props.scoreItem?.free_text ? 'stacked-layout' : 'left-right-layout');
  const transmittedValue = computed(() => {
    if(props.scoreItem?.free_text && lastPreviousScore.value?.value === currentValue.value) return null;
    else return currentValue.value;
  });
  const usesPreviousValues = computed(() => !!usesUserInput.value)
  const showAllPreviousValues = computed(() => !!props.scoreItem?.show_all_previous_values && !!props.scoreItem.free_text);
  const usesUserInput = computed(() => !!props.scoreItem?.user_input)
  const shownSyncedScores = computed(() => {
    if(!props.scoreItem?.synced_scores) return [];

    return props.scoreItem.synced_scores.map((scoreItem: any) => ({
      ...scoreItem,
      scores: scoreItem.scores.length > 0 ? scoreItem.scores[0] : null,
    }));
  });

  const selectItem = (value: any) => {
    if (props.scoreItem?.readonly) return;
    else if (value && value.value === currentValue.value) {
      // already selected?
      currentValue.value = null;
    } else if (value) {
      currentValue.value = value.value;
    } else currentValue.value = null;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["hueish", [{ filtered: filtered.value }, _unref(themingCssClass)('light_background')]])
    }, [
      (usesUserInput.value && name.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "hidden",
            name: name.value,
            value: transmittedValue.value
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (collapsed.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["text collapse-text", [_unref(themingCssClass)('normal')]]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollapsed.value = !isCollapsed.value))
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.scoreItem.text), 1),
            _createTextVNode(" einblenden "),
            (transmittedValue.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4,
                  _createTextVNode(" (bereits bearbeitet) ")
                ], 64))
              : _createCommentVNode("", true)
          ], 2))
        : ((filtered.value))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["text filter-text", [_unref(themingCssClass)('normal')]])
            }, " Dieses Element wurde aufgrund des gewählten Filters ausgeblendet. ", 2))
          : (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), { key: 3 }, _createSlots({
              label: _withCtx(() => [
                (__props.scoreItem.text !== '.')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(__props.scoreItem.text) + " ", 1),
                      (__props.scoreItem.required)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("*")
                          ], 64))
                        : _createCommentVNode("", true),
                      (collapsible.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["text collapse-text", [_unref(themingCssClass)('normal')]]),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (isCollapsed.value = !isCollapsed.value))
                          }, " ausblenden ", 2))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (usesUserInput.value)
                ? {
                    name: "user-input",
                    fn: _withCtx(() => [
                      (__props.scoreItem.free_text)
                        ? (_openBlock(), _createBlock(ScoreItemText, {
                            key: 0,
                            modelValue: currentValue.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentValue).value = $event)),
                            readonly: __props.scoreItem.readonly
                          }, null, 8, ["modelValue", "readonly"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.scoreItem.previous_scores || []).slice(1), (value) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: value.id
                        }, [
                          (showAllPreviousValues.value)
                            ? (_openBlock(), _createBlock(ScoreItemText, {
                                key: 0,
                                modelValue: value.value,
                                "onUpdate:modelValue": ($event: any) => ((value.value) = $event),
                                readonly: __props.scoreItem.readonly
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scoreItem.score_levels, (scoreLevel) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: 'user-input--' + scoreLevel.id
                        }, [
                          (__props.scoreItem.score_levels)
                            ? (_openBlock(), _createBlock(ScoreItemBubble, {
                                key: 0,
                                class: "bubble bubble--user-input",
                                onTrigger: ($event: any) => (selectItem(scoreLevel)),
                                "score-level": scoreLevel,
                                "current-value": currentValue.value
                              }, null, 8, ["onTrigger", "score-level", "current-value"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    key: "0"
                  }
                : undefined,
              (__props.scoreItem.keywords_html)
                ? {
                    name: "keywords",
                    fn: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "keywords",
                        innerHTML: __props.scoreItem.keywords_html
                      }, null, 8, _hoisted_6)
                    ]),
                    key: "1"
                  }
                : undefined,
              (lastPreviousScore.value)
                ? {
                    name: "previous-input",
                    fn: _withCtx(() => [
                      (__props.scoreItem.free_text && lastPreviousScore.value.value !== currentValue.value)
                        ? (_openBlock(), _createBlock(ScoreItemText, {
                            key: 0,
                            label: "Letzter Eintrag",
                            readonly: "",
                            modelValue: lastPreviousScore.value.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lastPreviousScore.value.value) = $event)),
                            light: ""
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scoreItem.score_levels, (scoreLevel) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: 'previous-input--' + scoreLevel.id
                        }, [
                          (__props.scoreItem.score_levels)
                            ? (_openBlock(), _createBlock(ScoreItemBubble, {
                                key: 0,
                                class: "bubble bubble--previous-input",
                                light: "",
                                "score-level": scoreLevel,
                                "current-value": lastPreviousScore.value.value,
                                "hidden-if-inactive": true,
                                "tooltip-prefix": "Letzter Eintrag: "
                              }, null, 8, ["score-level", "current-value"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    key: "2"
                  }
                : undefined,
              _renderList(shownSyncedScores.value, (si, index) => {
                return {
                  name: `synced-input-${si.score_item_id}`,
                  fn: _withCtx(() => [
                    (si.scores)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (si.free_text)
                            ? (_openBlock(), _createBlock(ScoreItemText, {
                                key: 0,
                                label: "Externe Einschätzung",
                                readonly: "",
                                modelValue: si.scores.value,
                                "onUpdate:modelValue": ($event: any) => ((si.scores.value) = $event),
                                light: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(si.score_levels, (scoreLevel) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'previous-input--' + scoreLevel.id
                            }, [
                              (si.score_levels)
                                ? (_openBlock(), _createBlock(ScoreItemBubble, {
                                    key: 0,
                                    class: "bubble bubble--synced-input",
                                    black: "",
                                    "score-level": scoreLevel,
                                    "current-value": si.scores.value,
                                    "hidden-if-inactive": true,
                                    "tooltip-prefix": "Externe Einschätzung: "
                                  }, null, 8, ["score-level", "current-value"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                }
              }),
              (moreLabel.value)
                ? {
                    name: "more-button",
                    fn: _withCtx(() => [
                      _createVNode(ScoreItemShowMoreButton, {
                        class: "more-button print--hide",
                        label: moreLabel.value,
                        modelValue: showMore.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showMore).value = $event))
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    key: "3"
                  }
                : undefined
            ]), 1024))
    ], 2),
    (!filtered.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["more-text", { active: showMore.value }])
        }, [
          _createVNode(TabbedContent, { "tab-headers": {
            last: 'letzte Einträge',
            information: 'Weitere Informationen',
          } }, _createSlots({ _: 2 }, [
            (usesPreviousValues.value && !showAllPreviousValues.value)
              ? {
                  name: "last",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      ((__props.scoreItem.previous_scores || []).length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["previous-scores", {'previous-scores--free-text': __props.scoreItem.free_text}])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scoreItem.previous_scores, (previousScore) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["previous-score-container", {'previous-score-container--free-text': __props.scoreItem.free_text}]),
                                key: previousScore.id
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["previous-score-bubble", {'previous-score-bubble--free-text': __props.scoreItem.free_text}])
                                }, [
                                  (__props.scoreItem.free_text)
                                    ? (_openBlock(), _createBlock(ScoreItemText, {
                                        key: 0,
                                        readonly: "",
                                        modelValue: previousScore.value,
                                        "onUpdate:modelValue": ($event: any) => ((previousScore.value) = $event),
                                        light: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : (_openBlock(), _createBlock(ScoreItemBubble, {
                                        key: 1,
                                        "score-level": previousScore
                                      }, null, 8, ["score-level"]))
                                ], 2),
                                _createElementVNode("div", null, _toDisplayString(previousScore.exam_taken_at), 1)
                              ], 2))
                            }), 128))
                          ], 2))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Bisher noch nicht bewertet")
                          ], 64))
                    ])
                  ]),
                  key: "0"
                }
              : undefined,
            (hasAdditionalInfo.value)
              ? {
                  name: "information",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scoreItem.info_items, (infoItem) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: infoItem.id
                          }, [
                            _createVNode(InfoItem, { "info-item": infoItem }, null, 8, ["info-item"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1024)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})